<!-- @veltra/icons generated sha256:b21ec474526463d1 gen:8 source:src/svg/normal/send.svg -->
<script setup lang="ts">
defineOptions({ name: 'Send' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.333"
    viewBox="0 0 24 24"
  >
    <path
      d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11zm7.318-19.539-10.94 10.939"
    />
  </svg>
</template>
